export var STAGE_THEORY = 'theory';
export var STAGE_PLAY = 'play';
